import { ISelectData } from 'components/atoms/SelectComponent';

import { EJinyTyp } from 'enums/lei/leiJinyTypEnums';

export const leiJinyGeneral: ISelectData[] = [
    {
        labelcz: 'TRANSFORMATION_SUBSIDIARY_TO_BRANCH',
        value: EJinyTyp.TRANSFORMATION_SUBSIDIARY_TO_BRANCH
    },
    {
        labelcz: 'MERGERS_AND_ACQUISITIONS',
        value: EJinyTyp.MERGERS_AND_ACQUISITIONS
    },
    {
        labelcz: 'BREAKUP',
        value: EJinyTyp.BREAKUP
    },
    {
        labelcz: 'DEMERGER',
        value: EJinyTyp.DEMERGER
    },
    {
        labelcz: 'REVERSE_TAKEOVER',
        value: EJinyTyp.REVERSE_TAKEOVER
    },
    {
        labelcz: 'SPINOFF',
        value: EJinyTyp.SPINOFF
    },
    {
        labelcz: 'ABSORPTION',
        value: EJinyTyp.ABSORPTION
    },
    {
        labelcz: 'BANCRUPTCY',
        value: EJinyTyp.BANCRUPTCY
    },
    {
        labelcz: 'INSOLVENCY',
        value: EJinyTyp.INSOLVENCY
    },
    {
        labelcz: 'DISSOLUTION',
        value: EJinyTyp.DISSOLUTION
    },
    {
        labelcz: 'VOLUNTARY_ARRANGEMENT',
        value: EJinyTyp.VOLUNTARY_ARRANGEMENT
    },
    {
        labelcz: 'LIQUIDATION',
        value: EJinyTyp.LIQUIDATION
    }
];

export const leiJinyGovermentEntity: ISelectData[] = [
    {
        labelcz: 'DISSOLUTION',
        value: EJinyTyp.DISSOLUTION
    },
    {
        labelcz: 'BREAKUP',
        value: EJinyTyp.BREAKUP
    },
    {
        labelcz: 'DEMERGER',
        value: EJinyTyp.DEMERGER
    },
    {
        labelcz: 'BANCRUPTCY',
        value: EJinyTyp.BANCRUPTCY
    },
    {
        labelcz: 'INSOLVENCY',
        value: EJinyTyp.INSOLVENCY
    },

    {
        labelcz: 'VOLUNTARY_ARRANGEMENT',
        value: EJinyTyp.VOLUNTARY_ARRANGEMENT
    },
    {
        labelcz: 'LIQUIDATION',
        value: EJinyTyp.LIQUIDATION
    }
];

export const leiJinyBranch: ISelectData[] = [
    {
        labelcz: 'TRANSFORMATION_BRANCH_TO_SUBSIDIARY',
        value: EJinyTyp.TRANSFORMATION_BRANCH_TO_SUBSIDIARY
    },
    {
        labelcz: 'ACQUISITION_BRANCH',
        value: EJinyTyp.ACQUISITION_BRANCH
    }
];

export const leiJinyFund: ISelectData[] = [
    {
        labelcz: 'TRANSFORMATION_UMBRELLA_TO_STANDALONE',
        value: EJinyTyp.TRANSFORMATION_UMBRELLA_TO_STANDALONE
    },
    {
        labelcz: 'ABSORPTION',
        value: EJinyTyp.ABSORPTION
    },
    {
        labelcz: 'MERGERS_AND_ACQUISITIONS',
        value: EJinyTyp.MERGERS_AND_ACQUISITIONS
    }
];
